import t from "./design-system.es912.js";
import e from "./design-system.es910.js";
import o from "./design-system.es888.js";
import { isHTMLElement as m } from "./design-system.es861.js";
function i(r) {
  return ["html", "body", "#document"].indexOf(o(r)) >= 0 ? r.ownerDocument.body : m(r) && e(r) ? r : i(t(r));
}
export {
  i as default
};
//# sourceMappingURL=design-system.es911.js.map
